import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { PricingProvider } from './context/PricingContext';
function Root() {
  useEffect(() => {
    // Inject Utmify Meta Pixel
    ;
    (window as any).pixelId = '699af96d3d725a7be6354526';
    const a = document.createElement('script');
    a.setAttribute('async', '');
    a.setAttribute('defer', '');
    a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(a);
  }, []);
  return <PricingProvider data-id="element-322">
      <App data-id="element-323" />
    </PricingProvider>;
}
render(<Root data-id="element-324" />, document.getElementById('root'));